function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.37324 3.66628C5.37324 2.55859 6.28223 1.64961 7.38991 1.64961H15.3899C16.4976 1.64961 17.4066 2.55859 17.4066 3.66628V4.34961H15.9633H6.81566H5.37324V3.66628ZM6.65316 5.64961H4.07324V3.66628C4.07324 1.84062 5.56426 0.349609 7.38991 0.349609H15.3899C17.2156 0.349609 18.7066 1.84062 18.7066 3.66628V5.64961H16.1258L17.2966 15.0166H17.3897C19.9487 15.0166 22.0397 17.1076 22.0397 19.6666V21.6499H12.0397V32.3333H10.7397V21.6499H0.739746V19.6666C0.739746 17.1076 2.83076 15.0166 5.38975 15.0166H5.48228L6.65316 5.64961ZM7.96327 5.64961L6.79244 15.0163H15.9865L14.8157 5.64961H7.96327ZM5.38975 16.3166C3.54873 16.3166 2.03975 17.8256 2.03975 19.6666V20.3499H20.7397V19.6666C20.7397 17.8256 19.2308 16.3166 17.3897 16.3166H5.38975Z",
  fill: "#2F7067"
});

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 33,
    viewBox: "0 0 23 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.26a5ee33.svg";
export { ForwardRef as ReactComponent };